// assets
import { UserOutlined, UserSwitchOutlined, RiseOutlined } from '@ant-design/icons';

const icons = {
  UserOutlined,
  UserSwitchOutlined,
  RiseOutlined
};

const menuItems = {
  id: 'user-management',
  title: 'Người dùng',
  type: 'group',
  roles: ['admin', 'teacher'],
  children: [
    {
      id: 'role',
      title: 'Nhóm quyền',
      type: 'item',
      url: '/role',
      icon: icons.UserOutlined,
      target: false,
      visible: true,
      roles: ['admin']
    },
    {
      id: 'users',
      title: 'Người dùng',
      type: 'item',
      url: '/users',
      icon: icons.UserSwitchOutlined,
      target: false,
      visible: true,
      roles: ['admin']
    },
    {
      id: 'user-levels',
      title: 'Cấp độ người dùng',
      type: 'item',
      url: '/user-level',
      icon: icons.RiseOutlined,
      target: false,
      visible: true,
      roles: ['admin', 'teacher']
    },
    {
      id: 'profile',
      title: 'Trang cá nhân',
      type: 'item',
      url: '/profile',
      icon: icons.UserSwitchOutlined,
      target: false,
      visible: false,
      roles: ['admin', 'teacher', 'editor']
    }
  ]
};

export default menuItems;
